/**
 * O número de um documento como a loja o lê: seis dígitos, `000007` (F128).
 *
 * Pedido do dono: pedido, orçamento, venda — "tudo tem que ter número de 6
 * dígitos", como o código do produto. O banco continua guardando o número
 * inteiro (`7`); isto é só como ele aparece, no papel e na tela, e mora aqui
 * para o recibo, o orçamento e as listas dizerem a mesma coisa.
 *
 * Só completa com zeros, nunca corta: o documento 1234567 sai com sete
 * dígitos. Nulo é o rascunho que ainda não recebeu número.
 */
export const formatDocumentNumber = (value, empty = '—') => value === null || value === undefined || String(value).trim() === ''
    ? empty
    : String(value).trim().padStart(6, '0');
/**
 * O que a pessoa digitou na busca, pronto para casar com o número guardado.
 *
 * Quem lê `000007` no papel digita `000007`, e o banco guarda `7`: sem tirar os
 * zeros da frente, a busca não acharia o documento que está na mão dela. Texto
 * que não é só número volta como veio (é nome de cliente).
 */
export const documentNumberSearchTerm = (search) => /^\d+$/.test(search) ? search.replace(/^0+(?=\d)/, '') : search;
//# sourceMappingURL=document-number.js.map